import { render, staticRenderFns } from "./todayshearing.vue?vue&type=template&id=eb8155b0"
import script from "./todayshearing.vue?vue&type=script&lang=js"
export * from "./todayshearing.vue?vue&type=script&lang=js"
import style0 from "./todayshearing.vue?vue&type=style&index=0&id=eb8155b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./todayshearing.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports